import { mapResponseToContract } from "../../contracts/mappers/ContractMapper";
import { mapResponseToPayment } from "../../payments/mappers/PaymentMapper";
import { BillingPageSummaryResponse } from "../contracts/BillingPageSummaryResponse";
import { MemberBalanceResponse } from "../contracts/MemberBalanceResponse";
import { MonthEndReviewResponse } from "../contracts/MonthEndReviewResponse";
import { MonthlyStatementResponse } from "../contracts/MonthlyStatementResponse";
import { BillingPageSummary } from "../models/BillingPageSummary";
import { MemberBalance } from "../models/MemberBalance";
import { MonthEndReview } from "../models/MonthEndReview";
import { MonthlyStatement } from "../models/MonthlyStatement";

export const mapResponseToBillingPageSummary = (resp: BillingPageSummaryResponse): BillingPageSummary => ({
  counts: { ...resp.counts },
  attentionPayments: resp.attentionPayments.map(mapResponseToPayment),
  notYetRecordedMembers: resp.notYetRecordedMembers.map((m) => ({ ...m })),
  contractsMissingPayment: resp.contractsMissingPayment.map((c) => ({ ...c })),
});

export const mapResponseToMemberBalance = (resp: MemberBalanceResponse): MemberBalance => ({
  memberId: resp.memberId,
  memberFirstName: resp.memberFirstName,
  memberLastName: resp.memberLastName,
  contracts: resp.contracts.map(mapResponseToContract),
  recentPayments: resp.recentPayments.map(mapResponseToPayment),
  lowBalancePackIds: [...resp.lowBalancePackIds],
});

export const mapResponseToMonthEndReview = (resp: MonthEndReviewResponse): MonthEndReview => ({
  periodStart: resp.periodStart,
  periodEnd: resp.periodEnd,
  confirmedCount: resp.confirmedCount,
  drafts: resp.drafts.map((d) => ({
    ...d,
    isAdjusted: d.amountMinorUnits !== d.fullFeeMinorUnits,
    lines: (d.lines ?? []).map((l) => ({ ...l })),
  })),
});

export const mapResponseToMonthlyStatement = (resp: MonthlyStatementResponse): MonthlyStatement => ({
  year: resp.year,
  month: resp.month,
  currency: resp.currency,
  receivedMinorUnits: resp.receivedMinorUnits,
  outstandingMinorUnits: resp.outstandingMinorUnits,
  draftMinorUnits: resp.draftMinorUnits,
  voidedMinorUnits: resp.voidedMinorUnits,
  previousReceivedMinorUnits: resp.previousReceivedMinorUnits,
  previousOutstandingMinorUnits: resp.previousOutstandingMinorUnits,
  receivedByShape: resp.receivedByShape.map((s) => ({ ...s })),
  delivery: { ...resp.delivery },
  members: resp.members.map((m) => ({ ...m })),
});
